/**
 * Helper function to get the API base URL from environment variables
 * Fallback to a default URL if the environment variable is not set
 */
export const getBaseUrl = () => {
  const currentUrl = window.location.href;
  console.log('🔍 Determining API base URL from current URL:', currentUrl);

  if (currentUrl.includes("localhost:3000")) {
    const envUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    console.log(`🌐 Using .env API URL: ${envUrl}`);
    return envUrl;
  }

  if (currentUrl.includes("ledger-link.ai")) {
    const prodUrl = "https://autofolio-backend-prod.up.railway.app";
    console.log(`🌐 Using production API URL: ${prodUrl}`);
    return prodUrl;
  }

  if (
    currentUrl.includes("autofolio.pages.dev") ||
    currentUrl.includes("autofolio-staging.pages.dev")
  ) {
    const stagingUrl = "https://autofolio-backend-staging.up.railway.app";
    console.log(`🌐 Using staging API URL: ${stagingUrl}`);
    return stagingUrl;
  }

  // Fallback to localhost
  const fallbackUrl = "http://localhost:5000";
  console.log(`⚠️ Using fallback API URL: ${fallbackUrl}`);
  return fallbackUrl;
};